const Dropdown = ({ children }) => {
	return <div className="relative z-50 inline-block w-full">{children}</div>;
};

export default Dropdown;
